import { getConfig } from "../config/config";
import { decryptEnv } from "../helpers";
const { APP_BASE_SWARAJ_API_URL, APP_USER_ID, APP_PASSWORD, APP_HEAD_KEY, APP_HEAD_REQUEST_CODE } = getConfig();
export const getNetPositionNetWiseDetails = async () => {
    const localClientCode = localStorage.getItem("ClientCode") || "";
    try {
        const response = await fetch(`${APP_BASE_SWARAJ_API_URL}V9/NetPositionNetWise`, {
            method: "POST",
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json",
                UserID: decryptEnv(APP_USER_ID),
                Password: decryptEnv(APP_PASSWORD),
            },
            credentials: "include",
            body: JSON.stringify({
                head: {
                    appName: "5PTRADE",
                    appSource: "9",
                    appVer: "1.0",
                    osName: "Web",
                    key: decryptEnv(APP_HEAD_KEY),
                    requestCode: decryptEnv(APP_HEAD_REQUEST_CODE),
                },
                body: {
                    ClientCode: localClientCode,
                },
            }),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error("Error while fetching NetPositionNetWise:", error);
    }
};
